module.exports = __webpack_public_path__ + "static/media/trash--red.3765c559.svg";